'use client';
import { Button, Entering, TabBar, Typography } from 'components';
import useTabs from 'hooks/useTabs';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';

const DashboardTabsLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const t = useTranslations();

  const { activeTabIndex, tabs } = useTabs({
    context: 'translation',
    routes: ['translation_requests', 'tasks_in_progress']
  });

  return (
    <>
      <div
        className={cn(
          'w-7xl sticky top-20 z-50 w-[calc(100%_-_4px)] max-w-7xl bg-[hsl(200deg_60%_98.04%_/_0%)]',
          'backdrop-blur-md transition-colors duration-200 ease-in-out',
          'pt-10 md:ml-1 md:pl-3 md:pr-8 lg:ml-1 lg:pl-[28px] lg:pr-8'
        )}
      >
        <div className="flex w-full flex-row">
          <Entering offset={5} delay={0.2} duration={0.2} className="flex" position="top">
            <Typography variant="medium7xl" className="relative left-0 top-0 text-tertiary-100 ">
              {t('components.menu.title.overview')}
            </Typography>
          </Entering>
          <div className="relative top-0 ml-auto h-0 ">
            <Link href="/translation/new">
              <Entering offset={5} delay={0.2} duration={0.2} className="flex" position="top">
                <Button label={t('translation.create_translation_request')} className="w-56" />
              </Entering>
            </Link>
          </div>
        </div>
        <TabBar tabs={tabs} activeTabIndex={activeTabIndex} />
      </div>
      <div className="md:mx-4 lg:mx-8">{children}</div>
    </>
  );
};

export default DashboardTabsLayout;
